import { Chip } from '~/shared/ui'
import { MATCH_VERDICT_LABELS } from '../config'

export function MatchVerdictChip({ verdict }: { verdict: string | null | undefined }) {
  if (!verdict) return null

  return (
    <Chip
      rounded
      size="xs"
      success={verdict === 'correct'}
      error={verdict === 'wrong'}
      attention={verdict === 'in_tie'}
      title={MATCH_VERDICT_LABELS[verdict]?.description}
    >
      {MATCH_VERDICT_LABELS[verdict]?.label ?? verdict}
    </Chip>
  )
}
